/**
 * V2 Embed Section Configuration
 *
 * Maps V2 StepNode.content.embed paths for the WebEmbed screen type.
 *
 * V2 EmbedConfig:
 * - callback: { action: Trigger }
 * - inputs: { [key]: EmbedInput }
 * - outputs: { [key]: EmbedOutput }
 * - html: string (untyped, stored in Firestore)
 *
 * Sprint: schema-v2-migration, Sprint 4
 */

export interface V2EmbedInputItem {
  key: string;
  name: string;
  inputType: string;
  value: string;
}

export interface V2EmbedOutputItem {
  key: string;
  name: string;
  value: string; // localized value for current locale
}

export const V2_INPUT_TYPE_OPTIONS = [
  { value: 'string', label: 'String' },
  { value: 'int', label: 'Integer' },
  { value: 'double', label: 'Double' },
  { value: 'boolean', label: 'Boolean' },
];

export const DEFAULT_EMBED_STRUCTURE = {
  callback: { action: { kind: 'advance', edges: [] } },
  inputs: {},
  outputs: {},
  html: '',
};
